import Vue from 'vue'
import Vuex from 'vuex'
import environment from "./modules/environment"
import getRoomDetail from "./modules/getRoomDetail"
import getUserOnlyId from "./modules/getUserOnlyId"
import refresh from "./modules/refresh"
import timing from "./modules/timing"

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules:{
    environment,
    getRoomDetail,
    getUserOnlyId,
    refresh,
    timing
  },
  strict: debug,
  plugins: []
})